import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { externalLink } from '../../../../configs/externalLink'
import { useSelector } from 'react-redux'

export const TermsOfUse = () => {
  const locale = useSelector((state) => state.i18n.locale)

  const onClick = () => {
    window.open(externalLink.TERMS_OF_USE[locale], '__blank')
  }

  return (
    <Element
      elementName="span"
      className="cursorPointer"
      style={{ color: '#2C73E8' }}
      onClick={onClick}
    >
      <Translate value="cartAndOrders.orderInformation.ruleLink" />
    </Element>
  )
}
